import { render, staticRenderFns } from "./SupportMessageElement.vue?vue&type=template&id=3b86da60&scoped=true"
import script from "./SupportMessageElement.vue?vue&type=script&lang=js"
export * from "./SupportMessageElement.vue?vue&type=script&lang=js"
import style0 from "./SupportMessageElement.vue?vue&type=style&index=0&id=3b86da60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86da60",
  null
  
)

export default component.exports